import { apiGet, apiPost, apiPut, apiDelete } from "../../api/client";
import { IOrderTemplate } from "../../types";

/**
 * REST client for the `order_templates` resource. Mirrors `data/api/products.ts`
 * so template data is read and written exclusively through the API.
 */

const ORDER_TEMPLATES_PATH = "/api/order-templates/";

/** Serialized template payload sent as a JSON request body (e.g. `OrderTemplate.data()`). */
type OrderTemplatePayload = Record<string, unknown>;

/** Full template list for a workspace (no pagination). */
export const listOrderTemplates = async (
  token: string,
  workspaceId: string,
): Promise<IOrderTemplate[]> => {
  const envelope = await apiGet(token, ORDER_TEMPLATES_PATH, workspaceId);
  return (envelope?.data as IOrderTemplate[]) ?? [];
};

export const createOrderTemplate = async (
  token: string,
  workspaceId: string,
  template: OrderTemplatePayload,
): Promise<IOrderTemplate> => {
  const envelope = await apiPost(
    token,
    ORDER_TEMPLATES_PATH,
    template,
    workspaceId,
  );
  return envelope?.data as IOrderTemplate;
};

export const updateOrderTemplate = async (
  token: string,
  workspaceId: string,
  templateId: string,
  template: OrderTemplatePayload,
): Promise<IOrderTemplate> => {
  const envelope = await apiPut(
    token,
    `${ORDER_TEMPLATES_PATH}${templateId}`,
    template,
    workspaceId,
  );
  return envelope?.data as IOrderTemplate;
};

export const deleteOrderTemplate = async (
  token: string,
  workspaceId: string,
  templateId: string,
): Promise<void> => {
  await apiDelete(token, `${ORDER_TEMPLATES_PATH}${templateId}`, workspaceId);
};
